import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import GrandCanyonPackrafting from './pages/GrandCanyonPackrafting';
import reportWebVitals from './reportWebVitals';

const ARTICLE_PATH = '/grand-canyon-packrafting';
const pathname = window.location.pathname.replace(/\/$/, '') || '/';
const isPackraftArticle =
  pathname === ARTICLE_PATH || pathname === `${ARTICLE_PATH}/`;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isPackraftArticle ? <GrandCanyonPackrafting /> : <App />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
